import {MasterController} from './master_controller'

export default class extends MasterController {
    static targets = ['code', 'name', 'modal', 'iframe', 'noHeader']

    getParams() {
        return `&consumer_single_form[no_header]=true&consumer_single_form[code]=${this.codeTarget.value}`
    }

    searchCode(e) {
        super._searchCode(e, 'consumers')
    }

    checkCode() {
        super._checkCode('consumers')
    }

}
